import { render, staticRenderFns } from "./BackupPropertyAttorneysYN.vue?vue&type=template&id=3926291f"
import script from "./BackupPropertyAttorneysYN.vue?vue&type=script&lang=js"
export * from "./BackupPropertyAttorneysYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports